import { ProgressiveImage } from "@circle-react/components/shared/ProgressiveImage";

interface ImageVariants {
  large: string;
  medium: string;
  small: string;
  thumbnail: string;
}

interface RightSideProps {
  alt: string;
  image1x: string;
  imageVariants: ImageVariants;
}

export const RightSide = ({ image1x, imageVariants, alt }: RightSideProps) => (
  <div className="hidden h-full flex-1 lg:flex">
    <div className="h-full w-full">
      <div className="h-full w-full">
        <ProgressiveImage
          src={image1x}
          srcVariants={imageVariants}
          alt={alt}
          className="h-full w-full object-cover"
        />
      </div>
    </div>
  </div>
);
